




























































































































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { find } from 'lodash'

// Mixins
import Date from '@/mixins/Date'
import FieldReport from '@/mixins/FieldReport'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'

// Views
import ListAllProovers from '@/views/proovers/partials/ListAllProovers.vue'

@Component({
  components: {
    ModalWrapper,
    ListAllProovers
  }
})
export default class PartBox extends Mixins(Date, FieldReport) {
  hide: boolean = false
  part: any = {}
  showProoversModale = false

  @Prop({ type: String, default: null }) title: string
  @Prop() id: string|number
  @Prop({ type: Boolean, default: false }) initialHide: boolean
  @Prop({ type: Boolean, default: true }) editable: boolean
  @Prop({ type: String, default: '' }) state: string
  @Prop({ type: Number, default: 0 }) index: number
  @Prop({ type: Object, default: {} }) data: {}

  @Getter('infos', { namespace: 'user' }) userInfos
  @Getter('dropoff', { namespace: 'report' }) dropoff
  @Getter('canShowValues', { namespace: 'report' }) canShowValues
  @Getter('canEditValues', { namespace: 'report' }) canEditValues
  @Getter('canShowDropoffValues', { namespace: 'report' }) canShowDropoffValues
  @Getter('canEditDropoffValues', { namespace: 'report' }) canEditDropoffValues
  @Getter('isFinished', { namespace: 'report' }) isFinished
  @Getter('isWaiting', { namespace: 'report' }) isWaiting
  @Getter('isReturn', { namespace: 'report' }) isReturn
  @Action('updateGallery', { namespace: 'report' }) updateGallery

  get stateTextClass(): string {
    return `has-text-${this.state}`
  }

  get showText(): string {
    return ( this.initialHide ?
      this.$t('report.edit.header.security.show') : this.$t('report.edit.header.show')
    ) as string
  }

  get isHeader(): boolean {
    return this.id === 'header'
  }

  get hideText(): string {
    return ( this.initialHide ?
      this.$t('report.edit.header.security.hide') : this.$t('report.edit.header.hide')
    ) as string
  }

  updateField(emitter) {
    this.$emit('change', emitter)
  }

  created() {
    this.hide = this.initialHide || false
    this.part = this.data
  }

  get availablesHumanFields() {
    const companyField = find(this.part.infos, (field) => field.name === 'company')
    const firstNameField = find(this.part.infos, (field) => field.name === 'first_name')
    const lastNameField = find(this.part.infos, (field) => field.name === 'name')
    const fullNameField = find(this.part.infos, (field) => field.name === 'fullname')
    const emailField = find(this.part.infos, (field) => field.name === 'email')
    const phoneNumberField = find(this.part.infos, (field) => field.name === 'phone_number')

    return [
      {
        type: 'company',
        field: companyField
      },
      {
        type: 'firstName',
        field: firstNameField
      },
      {
        type: 'lastName',
        field: lastNameField
      },
      {
        type: 'fullName',
        field: fullNameField
      },
      {
        type: 'email',
        field: emailField
      },
      {
        type: 'phone',
        field: phoneNumberField
      }
    ].filter((field) => typeof field.field !== 'undefined')
  }

  updateFieldWithImport(object) {
    this.availablesHumanFields.forEach((item) => {
      if (object[item.type]) {
        if (this.canEditValues && !this.isReturn) {
          item.field.value = object[item.type]
        }
        if (this.isReturn && item.field.dropoff) {
          item.field.dropoffValue = object[item.type]
        }
      }
    })
  }

  importMyInfos() {
    this.updateFieldWithImport(this.userInfos)
  }

  importContact(proover) {
    this.showProoversModale = false
    this.updateFieldWithImport(proover)
  }

  openPhotoOnGallery(field, partID) {
    this.updateGallery({
      partID: partID.toString(),
      photoID: field.id
    })
  }
}
